"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var icons_1 = require("@tiendanube/icons");
var Thumbnail_Button_1 = __importDefault(require("./Thumbnail.Button"));
var __1 = require("..");
require("./Thumbnail.css");
function Add(_a) {
    var aspectRatio = _a.aspectRatio, width = _a.width, onClick = _a.onClick, _b = _a.disabled, disabled = _b === void 0 ? false : _b, ariaLabel = _a.ariaLabel, helperText = _a.helperText;
    return (React.createElement(Thumbnail_Button_1.default, { aspectRatio: aspectRatio, width: width, ariaLabel: ariaLabel, onClick: onClick, disabled: disabled, className: "nimbus--thumbnail-button-add" },
        React.createElement(icons_1.PlusCircleIcon, { size: "large" }),
        helperText && (React.createElement(__1.Text, { size: "small", appearance: "primary", bold: true, textAlign: "center" }, helperText))));
}
exports.default = Add;
//# sourceMappingURL=Thumbnail.Add.js.map